export default "/images/8d38b16e0681f1215c3c4f8f8ffa8ad1.avif";